import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { SearchInput } from './SearchInput';
import { FilterDrawer } from './FilterDrawer';
import { FilterIcon } from '@/assets/icons/filter-icon';
import { useResolution886ReportFile } from '@/context/Resolution886ReportFiles';
import type { FormData } from '@/context/Resolution886ReportFiles/types';
import * as S from './styles';

const { useFormInstance } = Form;

export function Filters() {
	const form = useFormInstance<FormData>();
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { filters, onSetFilter, onResetFilter } = useResolution886ReportFile();

	const formFieldName: keyof FormData = 'filters';

	const setNameDebounce = _.debounce(async (name?: string) => {
		const newFilters = { ...filters, name, file_name: name };
		onSetFilter(newFilters);
	}, 1000);

	function handleOnClose(): void {
		setIsOpen(false);
	}

	function handleOpenDrawerWithData(): void {
		form.setFieldsValue({
			[formFieldName]: {
				organization_id: filters.organization_id,
				company_id: filters.company_id,
				sector_id: filters.sector_id,
				line_id: filters.line_id,
				workstation_id: filters.workstation_id,
				upload_date:
					filters.start_date && filters.end_date
						? [moment(filters.start_date), moment(filters.end_date)]
						: undefined
			}
		});
		setIsOpen(true);
	}

	async function handleOnChange(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
		const name = event.target.value || undefined;
		setNameDebounce(name);
	}

	function handleOnClear(): void {
		form.setFieldValue([formFieldName, 'sector_id'], undefined);
		form.setFieldValue([formFieldName, 'line_id'], undefined);
		form.setFieldValue([formFieldName, 'workstation_id'], undefined);
		form.setFieldValue([formFieldName, 'upload_date'], undefined);
		form.setFieldValue([formFieldName, 'organization_id'], filters.organization_id);
		form.setFieldValue([formFieldName, 'company_id'], filters.company_id);
		onResetFilter();
	}

	async function handleOnSubmit(): Promise<void> {
		const { filters } = form.getFieldsValue(true);
		const [startDate, endDate] = filters?.upload_date || [];

		const start_date = startDate?.startOf('day').toISOString();
		const end_date = endDate?.endOf('day').toISOString();

		const data = {
			...filters,
			offset: 1,
			start_date,
			end_date
		};

		onSetFilter(data);
		handleOnClose();
	}
	return (
		<Row align="middle" justify="space-between" style={{ width: '100%' }}>
			<Col flex="1" style={{ marginRight: 16 }}>
				<Form.Item name={[formFieldName, 'file_name']} style={{ margin: 0 }}>
					<SearchInput onChange={handleOnChange} placeholder={I18n.get('Search for a file')} />
				</Form.Item>
			</Col>
			<Col flex="none">
				<S.IconButton type="link" icon={<FilterIcon />} onClick={handleOpenDrawerWithData} />
			</Col>
			<FilterDrawer
				open={isOpen}
				fieldName={formFieldName}
				onClear={handleOnClear}
				onClose={handleOnClose}
				onSubmit={handleOnSubmit}
			/>
		</Row>
	);
}
